import { ClickAwayListener } from '@material-ui/core';
import {
  Block,
  ItemListFirst,
} from '@pages/Products/components/OnBoardingModal/components/styles';
import React from 'react';
import { CSSTransition } from 'react-transition-group';

export interface ICloseItem {
  text: string;
  onClick: React.MouseEventHandler<HTMLElement>;
  status?: 'ERROR';
}

interface CloseDialogProps {
  isOpen: boolean;
  itemList: ICloseItem[];
  /* This should ONLY close the modal because it can be called twice during a close */
  onClose: VoidFunction;
  onClickAway: VoidFunction;
  /**  Block positon. */
  position?: 'ADD-MORE' | 'CLOSE' | null;
}

export const CloseDialog = ({
  isOpen,
  onClose,
  itemList,
  onClickAway,
  position,
}: CloseDialogProps) => {
  const handleClickAway = () => {
    if (!isOpen) return;
    onClickAway();
    onClose();
  };
  const items = itemList.map(item => {
    const { status, text, onClick } = item;
    // If this expands, extract to "getClassName fn"
    const _className = status === 'ERROR' ? 'error' : undefined;
    return (
      <ItemListFirst
        key={text}
        className={_className}
        onClick={(...args) => {
          onClick(...args);
          onClose();
        }}
      >
        {text}
      </ItemListFirst>
    );
  });
  return (
    <CSSTransition in={isOpen} timeout={300} classNames="my-node" unmountOnExit>
      <ClickAwayListener onClickAway={handleClickAway}>
        <Block data-position={position ?? 'CLOSE'}>{items}</Block>
      </ClickAwayListener>
    </CSSTransition>
  );
};
